import { render, staticRenderFns } from "./RewardInfo.vue?vue&type=template&id=f2682a9e&scoped=true"
import script from "./RewardInfo.vue?vue&type=script&lang=js"
export * from "./RewardInfo.vue?vue&type=script&lang=js"
import style0 from "./RewardInfo.vue?vue&type=style&index=0&id=f2682a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2682a9e",
  null
  
)

export default component.exports